export default __webpack_public_path__ + "static/media/pow-3-thumb.b0bdcc7d.jpg";